const videosSection = document?.querySelectorAll(".video-section");
videosSection?.forEach((el) => {
  const video = el?.querySelector("video");
  const image = el?.querySelector("img");
  const playBtn = el?.querySelector(".play-btn");

  image?.addEventListener("click", function () {
    if (image) {
      image.style.display = "none";
    }
    if (playBtn) {
      playBtn.style.display = "none";
    }
    if (video) {
      video.play();
    }
  });
});
